import Layout from '../components/Layout';
import AgentsComponent from '../components/Agents';

function Agents() {
  return (
    <Layout>
      <AgentsComponent />
    </Layout>
  );
}

export default Agents;
